'use strict'

const CONSTANTS = require('../constants/constants');
var productListingViewdPushed = window.productListingViewdPushed != null && window.productListingViewdPushed.length > 0 ? window.productListingViewdPushed : [];

/**
 * Function that returns current page from actual url
 * @returns {string|boolean}
 */
function getCurrentPage(){
    var url = window.location.href;
    var regex = /(?:\?|&)page=(\d+)(?=&|$)/;
    var match = url.match(regex);

    return match ? match[1] : false;
}


/**
 * Handles view list event push, by limiting 10 items for each event
 * @param data
 */
function pushViewListEvent(data){
    if (typeof dataLayer !== 'undefined') {
        const SearchResultPageEventHelper = require('./searchResultPageEventHelper');

        var originalSize = data.eventData.items.length;
        var iterations = Math.ceil(originalSize / 10);
        for(let i = 0; i < iterations; i++){
            var until = 10 * (i+1);
            if(originalSize - (i * 10) < 10)
                until = originalSize;
            dataLayer.push({
                event : CONSTANTS.EVENT_LIST_NAME.VIEW_LIST,
                ecommerce : {
                    items : data.eventData.items.slice((10 * i), until)
                }
            });
        }

        SearchResultPageEventHelper.onViewItemList();
    }
}


/**
 * Remove product event function
 */
function removeProduct(event, data){
    if (typeof dataLayer !== 'undefined') {
        
        if (!data.analyticsData){
            console.error('Remove item analytics failed');
            return;
        }
    
        //STEP 2: Build and push data to analytics
        dataLayer.push(data.analyticsData);
    }
}


/**
 * Handles tile click event
 */
function clickTile(event, isWishlist){

    // If click was on wishlist heart, don't push event
    const button = $(event.target).closest('button');
    if (button.length) {
        if(button.hasClass('wishlistTile')){
            return;
        }
    }

    if (typeof dataLayer !== 'undefined') {
        const SearchResultPageEventHelper = require('./searchResultPageEventHelper');
        SearchResultPageEventHelper.onSelectItemPending();
        
        event.preventDefault();
        var $this = $(event.target);
        var contextEvent = $this.closest('[data-analytics-name]').data('analyticsName');
    
        let redirect = true;
        let detailViewEventUrl = $('body .js-ga4-dataset').data('viewevent');
    
        // IF QUICK BUY CLICKED DON'T REDIRECT
        if(event){
            if($(event.target).is('svg') || $(event.target).is('use') || $(event.target).hasClass('quickview') || $(event.target).hasClass('cc-icon--shopping-bag-2')){
                redirect = false;
            }
        } 
    
        //STEP 1 -- Get redirect url
        let analyticsUrl = $('#search-result-items').data('analytics');
        if(!analyticsUrl){
            analyticsUrl = $('.js-ga4-dataset').data('carouseltile');
            analyticsUrl = analyticsUrl.replace(/(context=)[^&]+/, `$1${contextEvent}`);
        }
        let $buttonElement = $(event.currentTarget);
        let pid = $buttonElement.find('.data-itemid').data('itemid')
        let variation = $buttonElement.find('.data-itemid').data('variation')
        let product = variation ? variation : pid;
    
        if(!product){
            product = event.currentTarget.dataset.pid;
        } 
    
        var redirectUrl = $buttonElement.find('.js-tile-url').attr('href');
        var index = Array.from(document.getElementsByClassName('js-tile')).indexOf(this) + 1;
    
        //STEP 2 -- Get analytics data
        $.ajax({
            type: 'GET',
            url: analyticsUrl + '&index=' + index + '&productString=' + product,
            success: function (data) {
                //STEP 3: Check data existence
                if (!data || !data.eventData){
                    // console.error('Tile click analytics failed');
                    SearchResultPageEventHelper.clearSelectItemPending();

                    //Redirect to destination anyways
                    if(redirect) handleClickLink(event, redirectUrl);
                    return;
                }
    
                //STEP 4: Build and push data to analytics
                dataLayer.push({
                    event : CONSTANTS.EVENT_LIST_NAME.SELECT_PRODUCT,
                    ecommerce : data.eventData
                });

                SearchResultPageEventHelper.onSelectItem();
    
                if(!redirect){
                    viewProductEvent(detailViewEventUrl, product, contextEvent);
                }
    
                //STEP 5: Redirect to destination
                if(redirect && !isWishlist){
                    handleClickLink(event, redirectUrl);
                } 
            },
            error: function () {
                SearchResultPageEventHelper.clearSelectItemPending();
            }
        });
    }
}

/**
 * Handles login form submit
 */
function submitLoginForm(event){

    if (typeof dataLayer !== 'undefined') {
        
        event.preventDefault();
    
        const util = require('../util');
        var currentForm = $(this);
        if(!currentForm){
            console.error('Could not find the form: login error');
            return false;
        }
    
        //STEP 0 -- Understand if this is the first form submit
        if($(this).hasClass('fired'))
            return false;
        $(this).addClass('fired');
    
        //STEP 1 -- Submit form action
        $.ajax({
            type: 'POST',
            url: util.ajaxUrl(currentForm.attr('action')) + '&action=' + event.data.action,
            data: currentForm.serialize(),
            success: function (data) {
                //STEP 2: Check data existence
                if (!data){
                    console.error('Login update analytics failed');
                    return;
                }
    
                //STEP 3 -- Push data to analytics
                if(data.analyticsData)
                    dataLayer.push(data.analyticsData);
            },
        })
    }
}


/**
 * PRIVATE FUNCTIONS
 */


/**
 * Redirects to a given URL in a new tab if Ctrl/Click is pressed, otherwise in the same tab.
 */
function handleClickLink(event, redirectUrl){
    // Check if the Ctrl key is pressed
    if (event.ctrlKey || event.metaKey) {
        // Open the link in a new tab
        window.open(redirectUrl, '_blank');
    } else {
        // Open the link in the same tab
        location.href = redirectUrl;
    }
}

function viewProductEvent(url, product, contextEvent) {

    if (typeof dataLayer !== 'undefined') {

        var urlEvent = $('.js-ga4-dataset').data('productdata');
        if (product) {
            urlEvent = urlEvent.split('productString')[0] + 'productString=' + product;

            if (contextEvent) {
                urlEvent += `&context=${contextEvent}`;
            }

            //STEP 1: Update cart
            $.ajax({
                type: 'GET',
                url: urlEvent,
                success: function (data) {
                    //STEP 1: Check data existence
                    if (!data || !data.eventData) {
                        console.error('PDP view analytics failed');
                        return;
                    }

                    //STEP 2: Build and push data to analytics
                    dataLayer.push({
                        event: CONSTANTS.EVENT_LIST_NAME.VIEW_PRODUCT,
                        ecommerce: data.eventData
                    });
                },
            });
        }
    }
}

/**
 * Handles gift card view_item event push
 * @param {string} contextEvent - Optional analytics list context
 */
function viewGiftCardEvent(contextEvent) {
    if (typeof dataLayer === 'undefined') {
        return;
    }

    var urlEvent = $('.js-ga4-dataset').data('giftcarddata');
    if (!urlEvent) {
        console.error('Gift card view analytics failed: missing endpoint');
        return;
    }

    var selectedAmount = $('input[name="giftcardAmount"]:checked').val();
    if (selectedAmount === 'custom') {
        selectedAmount = $('#giftcardAmount-customValue').val();
    }

    if (selectedAmount) {
        urlEvent += (urlEvent.indexOf('?') > -1 ? '&' : '?') + 'amount=' + encodeURIComponent(selectedAmount);
    }

    if (contextEvent) {
        urlEvent += '&context=' + encodeURIComponent(contextEvent);
    }

    $.ajax({
        type: 'GET',
        url: urlEvent,
        success: function (data) {
            if (!data || !data.eventData) {
                console.error('Gift card view analytics failed');
                return;
            }

            dataLayer.push({
                event: CONSTANTS.EVENT_LIST_NAME.VIEW_PRODUCT,
                ecommerce: data.eventData
            });
        },
    });
}

/**
 * Pushes gift card add_to_cart event to the dataLayer
 * @param {Object} analyticsData - Analytics payload returned by Cart-AddGiftCard
 */
function pushGiftCardAddToCartEvent(analyticsData) {
    if (typeof dataLayer === 'undefined') {
        return;
    }

    if (!analyticsData || analyticsData.event !== CONSTANTS.EVENT_LIST_NAME.ADD_TO_CART || !analyticsData.ecommerce) {
        return;
    }

    dataLayer.push(analyticsData);
}

/**
 * Pushes gift card remove_from_cart event to the dataLayer
 * @param {Object} analyticsData - Analytics payload returned by Cart-RemoveProductLineItem
 */
function pushGiftCardRemoveFromCartEvent(analyticsData) {
    if (typeof dataLayer === 'undefined') {
        return;
    }

    if (!analyticsData || analyticsData.event !== CONSTANTS.EVENT_LIST_NAME.REMOVE_FROM_CART || !analyticsData.ecommerce) {
        console.error('Gift card remove from cart analytics failed');
        return;
    }

    dataLayer.push(analyticsData);
}

function editorialViewItemList() {
    productListingViewdPushed = window.productListingViewdPushed != null && window.productListingViewdPushed.length > 0 ? window.productListingViewdPushed : productListingViewdPushed;
    var grid = $('.search-result-items');
    let analyticsUrl = grid.data('analytics');
    if (!analyticsUrl || analyticsUrl === '')
        return false;

    const EventHelper = require('../helpers/eventHelper');
    let products = $('.product .cc-tile__body');
    let processedProducts = [];
    let productString = '';

    if(products.length === 0)
        return false;

    products.each(function (index, product) {
        if (isElementInViewport($(product))) {
            let pid = $(product).closest('.product').data('pidvariant');
            if (!productListingViewdPushed.includes(pid)) {
                processedProducts.push(pid);
                productListingViewdPushed.push(pid);
                window.productListingViewdPushed = productListingViewdPushed;
            }
        }
    });
    productString = processedProducts.join(';');

    if (!productString) {
        return false;
    }

    $.ajax({
        type: 'GET',
        url: analyticsUrl + '&productString=' + productString,
        success: function (data) {
            //STEP 5: Check data existence
            if (!data || !data.eventData) {
                console.error('List view analytics failed');
                return;
            }

            EventHelper.pushViewListEvent(data);
        },
    });
}

/* HELPERS */
function isElementInViewport($element) {
    var elementTop = $element.offset().top;
    var elementBottom = elementTop + $element.outerHeight();
  
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
  
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

module.exports = {
    pushViewListEvent : pushViewListEvent,
    getCurrentPage : getCurrentPage,
    removeProduct : removeProduct,
    clickTile : clickTile,
    submitLoginForm : submitLoginForm,
    editorialViewItemList: editorialViewItemList,
    viewGiftCardEvent: viewGiftCardEvent,
    pushGiftCardAddToCartEvent: pushGiftCardAddToCartEvent,
    pushGiftCardRemoveFromCartEvent: pushGiftCardRemoveFromCartEvent
}
